import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Page404 from '../../components/Page404';
import UserProductPackageOrderList from './UserProductPackageOrderList';
import ProductPackageList from './ProductPackageList';
import ProductPackage from './ProductPackage';

const ProductPackageRoute = () => {
  const { url } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        path={`/ProductPackages/UserProductPackageOrderList`}
        component={UserProductPackageOrderList}
      />
      <Route
        exact
        path={`/ProductPackages/ProductPackageList`}
        component={ProductPackageList}
      />
      <Route
        exact
        path={`/ProductPackages/ProductPackage/:id?`}
        component={ProductPackage}
      />
      <Route component={Page404} />
    </Switch>
  );
};

export default ProductPackageRoute;
